import { peakDaySettingRepository } from '@/repositories/Index'

class PeakDaySettingService {
	async getPeakDayCalendar(params: any) {
		const res = await peakDaySettingRepository.getPeakDayCalendar(params)
		return res
	}
}

export default PeakDaySettingService
